import { round } from 'lodash-es'
import {
  ONE_HOUR_TIMESTAMP,
  ONE_MINUTE_TIMESTAMP,
} from '@/components/patient-stats/graphs/mapping-chart-options/constants'
import moment from 'moment-timezone'

export function getSingularOrPlural(num: number, singular: string, plural: string): string {
  return num == 1 ? singular : plural // Brayden: Changed to == 1. 0 and negatives should be plural
}

export function withSingularOrPluralLabel(num: number, singular: string, plural: string): string {
  return `${num} ${getSingularOrPlural(num, singular, plural)}`
}

export function durationTimestampToTimeLabel(timestamp: number) {
  const hours = Math.floor(timestamp / ONE_HOUR_TIMESTAMP)
  const minutes = round((timestamp % ONE_HOUR_TIMESTAMP) / ONE_MINUTE_TIMESTAMP)
  const hourLabel = withSingularOrPluralLabel(hours, 'hour', 'hours')
  const minLabel = withSingularOrPluralLabel(minutes, 'minute', 'minutes')

  return [hours === 0 ? null : hourLabel, minLabel].join(' ')
}

export function joinWith(labels: string[], basicLetter: string = ',', lastLetter: string = 'and') {
  if (labels.length <= 1) {
    return labels[0]
  } else if (labels.length === 2) {
    return `${labels[0]} ${lastLetter} ${labels[1]}`
  } else {
    return `${labels.slice(0, labels.length - 1).join(`${basicLetter} `)} ${lastLetter} ${labels[labels.length - 1]}`
  }
}

export function buildMonthPeriod(monthsAgo: number, includeMonthNames: boolean = false): object {
  let monthLabels = ['MONTH', 'MONTHS']
  let numMonths = withSingularOrPluralLabel(monthsAgo, monthLabels[0], monthLabels[1])
  let month = moment()
    .startOf('month')
    .subtract(monthsAgo, 'months')
    .format('MMM')
    .toUpperCase()
  let timeSince = monthsAgo == 0 ? 'this month' : `${numMonths.toLowerCase()} ago`
  let label = includeMonthNames ? `${month} (${timeSince})` : numMonths
  return {
    months: monthsAgo,
    label: label,
  }
}
